import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-pink-50 to-purple-50 flex items-center justify-center px-4">
      <div className="text-center">
        {/* 로고 */}
        <h1 className="text-6xl md:text-7xl font-black bg-gradient-to-r from-pink-500 via-purple-500 to-blue-400 bg-clip-text text-transparent mb-4 tracking-tight" style={{ textShadow: '0 0 30px rgba(236, 72, 153, 0.3)' }}>
          MyFanHub
        </h1>
        <div className="flex items-center justify-center gap-2 text-gray-600 mb-12">
          <p className="text-lg">당신만의 팬 플랫폼</p>
          <div className="flex gap-1">
            <i className="ri-heart-fill text-pink-400 text-2xl"></i>
            <i className="ri-star-fill text-yellow-400 text-2xl"></i>
          </div>
        </div>

        {/* 버튼 */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
          <Link
            to="/login"
            className="px-8 py-4 bg-gradient-to-r from-pink-500 to-purple-500 text-white rounded-full font-bold text-lg hover:shadow-2xl hover:scale-105 transition-all whitespace-nowrap"
          >
            시작하기
          </Link>
          <Link
            to="/creator/dashboard"
            className="px-8 py-4 bg-white/90 backdrop-blur-sm text-pink-600 rounded-full font-bold text-lg hover:shadow-xl hover:scale-105 transition-all border-2 border-pink-200 whitespace-nowrap"
          >
            크리에이터 대시보드 →
          </Link>
          <Link
            to="/fan/dashboard"
            className="px-8 py-4 bg-white/90 backdrop-blur-sm text-purple-600 rounded-full font-bold text-lg hover:shadow-xl hover:scale-105 transition-all border-2 border-purple-200 whitespace-nowrap"
          >
            팬 대시보드 →
          </Link>
        </div>

        {/* 데모 링크 */}
        <div className="mt-12 p-6 bg-white/60 backdrop-blur-sm rounded-2xl border border-pink-100 inline-block">
          <p className="text-sm text-gray-600 mb-3">빠른 데모 보기</p>
          <Link
            to="/creator/dashboard"
            className="text-pink-600 hover:text-pink-700 font-semibold cursor-pointer"
          >
            크리에이터 대시보드 →
          </Link>
        </div>
      </div>
    </div>
  );
}
